<app-header sectionName="Players">
  <span class="last-update">Updated {{ lastUpdate }}s ago</span>

  <button mat-icon-button (click)="refreshPlayers()" matTooltip="Refresh">
    <mat-icon>refresh</mat-icon>
  </button>

  @if (canEdit) {
  <button mat-stroked-button (click)="autoUpdate()" matTooltip="Trigger auto price update">
    Auto Update
  </button>

  <button mat-stroked-button (click)="openBulkUpdateDialog()">
    <mat-icon>edit_note</mat-icon>
    Bulk Update
  </button>

  <button mat-flat-button (click)="openCreateDialog()">
    <mat-icon>add</mat-icon>
    Add Player
  </button>
  }
</app-header>

<main class="page">
  <!-- Filters Section -->
  <div class="list-toolbar">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Quality</mat-label>
      <mat-select [(ngModel)]="filterQuality" (ngModelChange)="applyFilters()">
        <mat-option value="">All</mat-option>
        @for (option of qualityOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
      <mat-icon matPrefix>grade</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Rarity ID</mat-label>
      <input matInput type="number" [(ngModel)]="filterRarityId" (ngModelChange)="applyFilters()"
        placeholder="Filter by rarity" />
      <mat-icon matPrefix>filter_list</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="filterActive" (ngModelChange)="applyFilters()">
        <mat-option value="">All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
      <mat-icon matPrefix>toggle_on</mat-icon>
    </mat-form-field>

    @if (filterQuality || filterRarityId || filterActive) {
    <button mat-button (click)="clearFilters()">
      <mat-icon>filter_alt_off</mat-icon>
      Clear filters
    </button>
    }
  </div>

  <div class="table-card">
  @if (loading && !players.length) {
  <div class="table-state">
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
    Loading players…
  </div>
  } @else {
  <div class="table-scroll">
    <table mat-table [dataSource]="players">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let player">
          <div class="player-name-cell">
            @if (player.image_path) {
            <img class="player-avatar" [src]="player.image_path" [alt]="player.name" />
            } @else {
            <mat-icon class="player-avatar-placeholder">person</mat-icon>
            }
            <span>{{ player.name }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="quality">
        <th mat-header-cell *matHeaderCellDef>Quality</th>
        <td mat-cell *matCellDef="let player">
          <span [class]="getQualityClass(player.quality)">
            {{ getQualityLabel(player.quality) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="rarity_id">
        <th mat-header-cell *matHeaderCellDef>Rarity</th>
        <td mat-cell *matCellDef="let player">{{ player.rarity_id }}</td>
      </ng-container>

      <ng-container matColumnDef="overall">
        <th mat-header-cell *matHeaderCellDef>Overall</th>
        <td mat-cell *matCellDef="let player">
          <span class="rating-badge">{{ player.overall }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="market_price">
        <th mat-header-cell *matHeaderCellDef>Market Price</th>
        <td mat-cell *matCellDef="let player">{{ player.market_price | number }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let player">
          <mat-slide-toggle [checked]="player.active" [disabled]="!canEdit" (change)="toggleActive(player)" color="primary">
            {{ player.active ? 'Active' : 'Inactive' }}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let player">
          @if (canEdit) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openEditDialog(player)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="deletePlayer(player)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  @if (players.length === 0) {
  <div class="table-state">
    <mat-icon>inbox</mat-icon>
    No players match these filters.
  </div>
  }

  <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
    [pageSizeOptions]="[25, 50, 100, 200]" (page)="onPage($event)">
  </mat-paginator>
  }
  </div>
</main>
